import { db } from "../../../service/API";

// CONNECTORS
import { ProjectConnector } from "./ProjectConnector";

// Tools
let sqlTool = require("../Tools/SQLTools");

export class ScheduleConnector {
  constructor(userData) {
    this.userId = userData.userId;
    this.socId = userData.socId;
    this.rightId = userData.rightId;
    this.projectConnector = new ProjectConnector(userData);
  }

  /**
   * This method link the players with the newly created schedule. The schedule is associated with a project. If this project doesn't exist in the DB, it creates it and associate it.
   * @param {Array} players The players being linked to the schedule
   * @param {Schedule} schedule The schedule with all his information, it will be inserted and associated to the players
   * @param {Object} projectData This object must at least contain the project path
   */
  addScheduleForPlayers(players, schedule, projectData) {
    return new Promise((resolve, reject) => {
      this.projectConnector
        .checkIfProjectExist(projectData.path)
        .then((data) => {
          if (data.length > 0) {
            const projectId = data[0].id_proj;
            const projectDuration = data[0].duration;

            this.insertScheduleForEachPlayer(projectId, projectDuration, schedule, players)
              .then(() => {
                return resolve("schedule inserted");
              })
              .catch((err) => {
                return reject(err);
              });
          } else {
            return reject("the project is not found");
          }
        })
        .catch((err) => {
          return reject("error checking project exist" + err.message);
        });
    });
  }

  collectPlayerSchedule(playersID, upload = false) {
    return new Promise((resolve, reject) => {
      let socId = this.socId;

      if (upload) {
        socId = "null";
      }

      db.post("/ScheduleConnector/collectPlayerSchedule/", {
        sid: socId,
        pid: playersID,
      })
        .then((response) => {
          if (response.status == 200) {
            const data = response.data;

            for (let i = 0; i < data.length; i++) {
              let tempo = {
                group: [
                  {
                    id_sched: data[i].id_sched,
                    plyr_id: data[i].plyr_id,
                  },
                ],
              };

              Object.assign(data[i], tempo);
            }

            return resolve(data);
          } else {
            return reject("collect player schedule failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("collect player schedule failed with error : " + err.message);
        });
    });
  }

  collectScheduleForPlayers(players, upload = false) {
    return new Promise((resolve, reject) => {
      this.collectPlayerSchedule(players, upload)
        .then((schedules) => {
          return resolve(schedules);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  }

  unsharedSchedule(players, nbSchedule) {
    return new Promise((resolve, reject) => {
      db.post("/ScheduleConnector/unsharedSchedule/", {
        sid: this.socId,
        players: players,
        nbSchedule: nbSchedule,
      })
        .then((response) => {
          if (response.status == 200) {
            const data = response.data;

            // TODO: format in db server
            for (let i = 0; i < data.length; i++) {
              Object.assign(data[i], {
                group: [{ id_sched: data[i].id_sched, plyr_id: data[i].id_plyr }],
              });
            }

            resolve(data);
          } else {
            return reject("unshared schedule failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("unshared schedule failed with error : " + err.message);
        });
    });
  }

  collectMinPlayerSchedule(players) {
    return new Promise((resolve, reject) => {
      db.post("/ScheduleConnector/collectMinPlayerSchedule/", {
        sid: this.socId,
        players: players,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("collect min player failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("collect min player failed with error : " + err.message);
        });
    });
  }

  async collectMinScheduleForPlayers(players) {
    const schedules = await this.collectMinPlayerSchedule(players);
    return schedules;
  }

  limitLoopTimeForPlayer(loopState, schedules, players) {
    return new Promise((resolve, reject) => {
      db.put("/ScheduleConnector/limitLoopTimeForPlayer", {
        loopState: loopState,
        schedules: schedules,
        players: players,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve();
          } else {
            return reject("limit loop failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("limit loop failed with error : " + err.message);
        });
    });
  }

  deleteScheduleForPlayer(group) {
    return new Promise((resolve, reject) => {
      db.delete("/ScheduleConnector/deleteScheduleForPlayer", {
        sid: this.socId,
        group: group,
      })
        .then((response) => {
          if (response.status == 204) {
            return resolve();
          } else {
            return reject("delete schedule failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("delete schedule failed with error : " + err.message);
        });
    });
  }

  insertScheduleForEachPlayer(projectId, projectDuration, schedule, players) {
    return new Promise((resolve, reject) => {
      db.post("/ScheduleConnector/insertScheduleForEachPlayer", {
        pid: sqlTool.insertNullFormat(projectId),
        duration: projectDuration,
        dateFrom: sqlTool.insertNullFormat(schedule.dateFrom),
        dateTo: sqlTool.insertNullFormat(schedule.dateTo),
        timeFrom: sqlTool.insertNullFormat(schedule.timeFrom),
        timeTo: sqlTool.insertNullFormat(schedule.timeTo),
        players: players,
        schedule: schedule,
      })
        .then((response) => {
          if (response.status == 201) {
            return resolve(response.data);
          } else {
            return reject("insert schedule failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("insert schedule failed with error : " + err.message);
        });
    });
  }

  updateSchedulesInfo(schedules, unsharedSchedules) {
    return new Promise((resolve, reject) => {
      db.put("/ScheduleConnector/updateSchedulesInfo", {
        schedules: schedules,
        unsharedSchedules: unsharedSchedules,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve();
          } else {
            return reject("update schedule failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("update schedule failed with error : " + err.message);
        });
    });
  }

  checkDuplicateSchedule(players, projectPath) {
    return new Promise((resolve, reject) => {
      db.post("/ScheduleConnector/checkDuplicateSchedule/", {
        sid: this.socId,
        players: players,
        path: projectPath,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("check duplicate failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("check duplicate failed with error : " + err.message);
        });
    });
  }

  emptyScheduleForEachPlayer(players) {
    return new Promise((resolve, reject) => {
      db.delete("/ScheduleConnector/emptyScheduleForEachPlayer/", {
        sid: this.socId,
        players: players,
      })
        .then((response) => {
          if (response.status == 204) {
            return resolve();
          } else {
            return reject("empty schedule failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("empty schedule failed with error : " + err.message);
        });
    });
  }

  getAllProjectPlan() {
    return new Promise((resolve, reject) => {
      db.get("/ScheduleConnector/getAllProjectPlan/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get all project plan failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("get all project plan failed with error : " + err.message);
        });
    });
  }

  updateSchedulePlayerDuration(scheduleId, playerId, newDuration) {
    return new Promise((resolve, reject) => {
      db.post("/ScheduleConnector/updateSchedulePlayerDuration/" + scheduleId + "/" + playerId + "/" + newDuration)
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("update schedule player duration failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("update schedule player duration failed with error : " + err.message);
        });
    });
  }
}
